import aes from "crypto-js/aes";
import enc from "crypto-js/enc-base64";
import cryptojs from "crypto-js";

const KEY = "ekohbSw+GHRIqVkAHuY5N1qkNZQMaXCEHVfEpj/7N3c=";
const IV = "5X7dhJOAVkMaLR/FbA+DXA==";

export const EncryptAes = (value: string): string => {
  return aes.encrypt(value, enc.parse(KEY), { iv: enc.parse(IV) }).toString();
};

export const DecryptAes = (value: string): string | undefined => {
  try {
    return aes.decrypt(value, enc.parse(KEY), { iv: enc.parse(IV) }).toString(cryptojs.enc.Utf8);
  } catch (error) {
    return undefined;
  }
};
